import request from "./request";
import {createProduct, deleteProduct, updateProduct} from "../graphql/mutations";
import {graphqlOperation} from "aws-amplify";
import {getProductFilterFieldList, listProducts, searchProducts} from "../graphql/queries";

export const productApi = {
  listProducts: async function (variables) {
    const res = await request(
      graphqlOperation(listProducts, {
        ...variables,
        sort: { direction: "desc", field: "createdAt" },
      })
    );
    //res.listProducts.total = await this.getProductsCount(variables);
    return res.listProducts;
  },
  searchProducts: async (variables) => {
    const res = await request(
      graphqlOperation(searchProducts, {
        ...variables,
        sort: variables.sort ?? { direction: "desc", field: "createdAt" },
      })
    );
    return res.searchProducts;
  },
  updateProduct: async ({ updatedProduct }) => {
    return (
      await request(graphqlOperation(updateProduct, { input: updatedProduct }))
    ).updateProduct;
  },
  updateProductData: async (params) => {
    return (await request(graphqlOperation(updateProduct, params)))
      .updateProduct;
  },
  createProduct: async ({ newProduct }) => {
    return (
      await request(graphqlOperation(createProduct, { input: newProduct }))
    ).createProduct;
  },
  getProductFilterFieldList: async () => {
    return (await request(graphqlOperation(getProductFilterFieldList)))
      .getProductFilterFieldList;
  },
  getProductsCount: async (variables) => {
    const variablesCopy = JSON.parse(JSON.stringify(variables));
    let count = 0;
  
    if (variablesCopy.limit) {
      delete variablesCopy.limit;
    }
  
    let nextToken = null;
  
    do {
      const result = await request(
        graphqlOperation(listProducts, {
          ...variablesCopy,
          nextToken,
        })
      );
  
      count += result.listProducts.items.length;
      nextToken = result.listProducts.nextToken;
    } while (nextToken);
    return count;
  },
  deleteProduct: async (params) => {
    return (await request(graphqlOperation(deleteProduct, params)))
      .deleteProduct;
  }
};
